import { render } from "./BasePageSpinner.vue?vue&type=template&id=4bed839a&scoped=true"
import script from "./BasePageSpinner.vue?vue&type=script&lang=js"
export * from "./BasePageSpinner.vue?vue&type=script&lang=js"

import "./BasePageSpinner.vue?vue&type=style&index=0&id=4bed839a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bed839a"]])

export default __exports__